import {
  ContainerBox,
  Datenschutz,
  HeaderInterface
} from '@peakconcepts/landingpage-kit'
import seoHeaderData from '../../content/data/seoHeader'

import leadData from './data/lead'
import imprintData from './data/imprint'
import policyData from './data/policy'

export const headerConfig: HeaderInterface = {
  withContainer: true,
  containerConfig: {
    padding: {
      fullHd: '20px 0',
      widescreen: '20px 0',
      desktop: '20px 0',
      tablet: '20px 0',
      mobile: '10px 0'
    }
  },
  brandConfig: {
    className: 'ml-0',
    defaultCss: { justifyContent: 'center' },
    imageContainer: {
      className: 'p-0'
    },
    image: {
      src: '/images/logo.png',
      width: '120px',
      defaultCss: {
        maxHeight: 'unset !important'
      }
    }
  },
  burgerConfig: {
    hide: true
  }
}

const data = [
  {
    path: '/impressum',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.imprint,
    headerConfig,
    component: ContainerBox,
    data: {
      ...imprintData
    }
  },
  {
    path: '/datenschutz',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.policy,
    headerConfig,
    component: Datenschutz,
    data: {
      ...policyData
    }
  },
  {
    id: 'Danke',
    path: '/danke',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.thankYou,
    headerConfig,
    component: ContainerBox,
    data: {
      ...leadData
    }
  }
]

export default data
